export default "__VITE_ASSET__BSwvJ2eh__"